export default "__VITE_ASSET__DQdYaP7t__"